import { Injectable } from '@angular/core';
import { MojoFeatureExtensionsService } from 'mojo-feature-extensions';
import { AppFeatureExtensions } from '@app/app-feature-extensions.config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GreenhouseIntegrationService {
  constructor(private featureExtensionsService: MojoFeatureExtensionsService) {}

  // when the GH prospect pool synchronization is turned ON user cannot:
  // create/edit talent pools, remove candidates from pools
  isPoolSynchronizationOff() {
    return this.featureExtensionsService
      .hasFeatureExtension(AppFeatureExtensions.POOLS_SYNCHRONIZATION)
      .pipe(map((poolSynchronizationOn) => !poolSynchronizationOn));
  }
}
